<template>
  <div class="main-page">
    <Menu
      title="全国一体化在线政务服务平台“好差评”"
      :home="true"
    />
    <div class="container-flex">
      <div class="evaluationlist">
        <div class="item-name">
          <span class="evaluation-title">事项名称：</span>
          <span>法律援助律师工作证颁发</span>
        </div>
        <div class="start-evaluation">
          <div class="evaluation-title"><span class="red">*</span>整体评价：</div>
          <div class="start-box">
            <div
              v-for="n in 5"
              :key="n"
              @mouseenter="enter(n)"
              @mouseleave="leave()"
              @click="Selected(n)"
              :class="['start-off',{'on':cur>=n}]"
            ></div>
            <span class="start-desc">{{evaluationDesc}}</span>
          </div>
        </div>
        <div
          class="evaluation-type"
          v-if="evaluationType"
        >
          <div class="type-title">感谢您的评价，您可以在下列预设的理由中进行选择(可以多选)，也可以输入共他理由，以帮助相关部门及其工作人员持续改进服务质量，提高服务水平.</div>
          <div class="checkbox-input">
            <label
              v-for="(item,index) in checkboxList"
              :key="'key-ass'+index"
              :class="{'checked':evaluationForm.evalType.indexOf(index) !== -1 }"
              :for="index"
            >
              <input
                type="checkbox"
                :id="index"
                class="weui-check"
                @click="setEvalType(index)"
              >
              <div class="cells-check__icon" />
              <div class="cells-check__bd">
                <div class="cells-check__title">
                  {{item}}
                </div>
              </div>
            </label>
          </div>

        </div>
        <div class="textarea">
          <div class="textarea-title">文字评价：</div>
          <textarea
            v-model="evaluationForm.content"
            placeholder="请输入0～50字完成评价"
          ></textarea>
        </div>
        <div class="captcha">
          <label for="captcha">
            <span class="red">*</span>验证码：
            <!-- <div class="imgs">
              <img
                src="/img/ui/yzm.png"
                alt=""
              >
            </div> -->
            <input
              type="text"
              placeholder="请输入验证码"
              v-model="evaluationForm.captcha"
            >
          </label>
          <img
            class="captcha-img"
            src="https://zwfw.yn.gov.cn/portal/hcp/hcp01012?projectNo=11530000015100311J2000712001000202005090001&vcodeId=1589179309833"
            alt=""
          >
        </div>
        <div class="content-block">
          <div
            class="button button-big"
            @click="submitForm"
          >提交</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '../../components/Menu'
import { veryDissatisfied, dissatisfied, basicDissatisfied, satisfaction, verySatisfied } from './js/config.js'
export default {
  components: {
    Menu
  },
  data () {
    return {
      veryDissatisfied, // 非常不满意
      dissatisfied, // 不满意
      basicDissatisfied, // 基本满意
      satisfaction, // 满意
      verySatisfied, // 非常满意
      cur: -1,
      flag: false,
      evaluationForm: {
        evalType: [],
        content: '',
        captcha: '',
        evaluation: ''
      },
      evaluationType: false,
      checkboxList: [],
      evaluationDesc: '',
      checkedBox: 1,
      checkboxType: ''
    }
  },
  methods: {
    enter (idx) {
      if (!this.flag) {
        this.cur = idx
      }
    },
    leave () {
      if (!this.flag) {
        this.cur = -1
        this.evaluationDesc = ''
      }
    },
    Selected (n) {
      this.flag = true
      this.cur = n
      this.evaluationForm.evaluation = n
      this.startEvaluationDesc(this.cur)
    },
    startEvaluationDesc (cur) {
      if (cur === 1) {
        this.evaluationDesc = '非常不满意'
        this.evaluationType = true
        this.checkboxList = this.veryDissatisfied
        this.evaluationForm.evalType = []
      } else if (cur === 2) {
        this.evaluationDesc = '不满意'
        this.evaluationType = true
        this.checkboxList = this.dissatisfied
        this.evaluationForm.evalType = []
      } else if (cur === 3) {
        this.evaluationDesc = '基本满意'
        this.evaluationType = true
        this.checkboxList = this.basicDissatisfied
        this.evaluationForm.evalType = []
        this.checkboxList.forEach((e, i) => {
          this.evaluationForm.evalType.push(i)
        })
        console.log(this.evaluationForm.evalType)
      } else if (cur === 4) {
        this.evaluationDesc = '满意'
        this.evaluationType = true
        this.checkboxList = this.satisfaction
        this.evaluationForm.evalType = []
        this.checkboxList.forEach((e, i) => {
          this.evaluationForm.evalType.push(i)
        })
      } else if (cur === 5) {
        this.evaluationDesc = '非常满意'
        this.evaluationType = true
        this.checkboxList = this.verySatisfied
        this.evaluationForm.evalType = []
        this.checkboxList.forEach((e, i) => {
          this.evaluationForm.evalType.push(i)
        })
      }
    },
    setEvalType (key) {
      let isHash = this.evaluationForm.evalType.findIndex(item => item === key)
      if (isHash > -1) {
        this.evaluationForm.evalType.splice(isHash, 1)
        console.log(this.evaluationForm.evalType)
      } else {
        this.evaluationForm.evalType.push(key)
        console.log(this.evaluationForm.evalType)
      }
    },
    submitForm () {
      console.log(this.evaluationForm)
    }
  }
}
</script>

<style lang="stylus" scoped>
.evaluationlist
  width 10.8rem
  margin 0 auto
  color #fff
  .red
    color #ed4014
    margin-right 0.04rem
  .item-name
    font-size 0.26rem
    color #fff
    padding 0.1rem 0 0.3rem
    margin-left 0.1rem
  .start-evaluation
    display flex
    margin-bottom 0.3rem
    .evaluation-title
      font-size 0.26rem
      line-height 0.49rem
    .start-box
      display flex
      .start-off
        width 0.51rem
        height 0.49rem
        background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAxCAYAAAB3aZEhAAAEpElEQVRogdWaa4hVVRTHf0qOOaaMTUqhzajpOEI1Y0lYVBQURAQlgSgU+K0ioQ8ikdCbiMDefehDn6KIkB6UPRhKe9LDyp6M5uRrchKnUDPInHH+sYf/wTPX+9j3zp075y44bO45a6+zfvt191r7IGksr5skfSPpmKQdkm6XNGGs3jeWIOuVX56qN5ilkoYk/SfpDknTJK10DwVZXk8wm+z0Yzn3b/P9Pkkz6gHmEjt8VNLMnGdhvnzk58/XA8y7dvbRAs8XSTouaVDSBVmGWWaQvyU1F9F72npdWYZ5304+UkIvgP5l3euzCHOZnTsi6cwI/bXW31at/55qwnTZuYcj9adI+t11VmQJ5nI7dbjMJTdZqrslnZYVmA/t1INl1pskqcd1V2cB5ko7c0hSUwX1b3H93ZIaRuPL8MSLlGnAXKDVZYvLZcC5wP3AQ7HGUjIR+AE4H+gCtgDfAz8B+8sxlA9mBrAUuBBo97UYaC5i5xAwDzhSAUyQ5cDree73G2wb8KOhtwODxWCagDXACrfQhDy6/wK/AbuBvUAvsM9luH+gQhD8vtB4namrww2bK8eAnw0Wrk32aRimxV0735WC8rfu5qDcDfSU2+VVkpYcuA77mW7s0EvPAuvCxHnNEzAEUddKmlylFW6srumSrpC0RtLLDjOCrA898w8wFZgN9I1D649WrgPeCyMnrCQnbOxYHYIE+cJlc4D5yj9WjaNDo5FbXXdrGIM3esz1S2rP+HzJvdocBAa5OXn4jm/st0I9gMyR1Gu/X1VqO9Mo6QM/CDvZhRkHCeH4L/b3S/s/Ym8Wbmy2QiBekFGQ6QYIsjOdZ8hVbEwlHALQeRkDaUjt0E9p8HwVAtDHrrBP0vyMgIR45037dVDS4lydQhWnSvrEFfdKmjfOICHu2ZgKNTry6RUzcIakT21gj6S5GQG5uJBuKUMhrfpZKnhqzSpIDAxePT63wV3usVqANKQ2wSVBVEakeTbwBzDgTelADbYpIaLd43dd6rCkqEyMNDzLZU+NQHDQFza/k4AdMRViYRa53Fm5b2XLkBsvyIKYyrEwbS67x55hhCSNtzhGORam3WUte4bU8FoYoxwLkxjbXplPFUsC0xZjIBZmrsvdteMYlmQkRPVMzNJ8utNMx4Epnpi1kpnAQeBwgbTTCInpmVaXvTUGwUnAw87rzSylHAMz22VvBc6E/NZKZyQ3AOdUYONXlyXnTQxMkpb9s0wnrga+Bl5xEm8tsAt4zrnpWImeNzEwyb9/f+TLO53H2uycdciE3gW8AUwG7nRrPxkzdMrpmZgN3wORZy8tkl6UdCK1ObzHJ2SJTqcDrCHrHLVOsaOMVdbdWMrXcmDuK/A8HLZuSH19EdKlj0s6q4jNiyS9pZOys8hXG8l3BVurAbPaxjbl3A/h9d3uAblHXioz5rnKOe5Etrj38sF8Vw2YWR4OYWg84XPIZyQdSDkRjsyXVBi3THCD9dnWgKQX/E1Boz8ckhtq1DBJ7wzqVAl5gmsqhMi9mjxck6x+WsK7wyFwURvlHAMu8WFUWN3CYdPb/v+otoQzmXXADcAcr2b3FjhZOynA/3vffvDSSjbcAAAAAElFTkSuQmCC') no-repeat 0 center / 0.51rem 0.49rem
        margin-right 0.35rem
        cursor pointer
        &.on
          background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAxCAYAAAB3aZEhAAADP0lEQVRogd2aSWgUURCGvywuFyEhqIiSBNGYiIpLFBURFPcNF8wpF8GTKCKSiygmoHhSUQnqzYsXQYIoAQ/iEhVE1LjgAgEVDILjIUSN4s6TmjDOZLqru6snM/mhSZh+S31dr7urql9Rb+tMYtRGYD8wDXgLHAfOAn/imLI4RpB9QBswBxgB1ACnBSgWxQVTDxzKcm43sKmQYJqBIo/zrUC59aRxwMwD1vq0GQccsZ44DphmZbvtwHTLia1h5gOrlW1LgKOWk1vDaL2S1HJgjdXkljALgZUh+h32eVioZQkT1CtJubf2VgsDrGAWyZIJqxagNKoRVjAtEfvXAo1RjbCAWQwsNRjnIDA8ygBBXDsKqAaq5G+l/L8gigEpcmNeBq4DncBToDvIAAPBlEtsNUPc7446oMLIaC+tkCOphIA9Ap4Aj4GXwE8vmDJgJ9Ag4brJo9JAo+XBkvpw+QY8EzB3XAFeuxMun6kU107ME4Cgcl46BTSVSn5RqCDI6toDfCwO+dbOR+1wML+GCEyFg7mXB4ZY6H6xZH1DQScczCWgvcBhLgAXk+GMi1qvDbJBYeVuk22kxGZ9wAZ53xSSuoD1Yv9/gab7YR1ws0Bg3kmKnkj+kB4190kaeyv3tgVSQmK4rtROA6UASaCO/GP4px6J1V6kn8iWz3wRoNvx2xZIDmSZBJgZ8krOPgvQnTwDeZCtgV+m+UmA7trbFki+ICjT5l5gS+7t79cPDQgBagBjbOwKpWHAK01HLcyU3NqfoUmaRlqYGju7QqlO00kLU5tb2zM0WdNIC6MaLEapVoYWpnqQYcw8MxIYG92eSDLzTNXgMfSrTGpontLAjI/fVpV8vaOByUVZViPf+0YDE/Xt3y3f/tsi7sww8YzvWs2iHtml4a7oSWAzMFsKKGGgTDwTVN+BYzK5+9b/NaV/p+ynqZfPF0Hk+3rQwLxRTvgbOC/LYa+r/Xq0fSgFlCWaaFhU4tdAA9MuiZqXrsrVbpTdS1rdAOZKqei9T5/nFjAfgF1ZatIdko+vkg9CYeTun3PAVNnk4JZputzcZ/zGDrLfbJYUC1004K6+W/NhAbzkvhc1SdlrghQuDsiDI7uAv8yVhrYyOzUXAAAAAElFTkSuQmCC') no-repeat 0 center / 0.51rem 0.49rem
      .start-desc
        color #F29530
        line-height 0.49rem
        font-size 0.24rem
        font-weight 400
  .evaluation-type
    margin-left 1.5rem
    padding-top 0.1rem
    .type-title
      font-size 0.2rem
      line-height 0.32rem
    .checkbox-input
      margin-top 0.2rem
      label
        display flex
        cursor pointer
        height 0.35rem
        align-items center
        &.checked
          .cells-check__icon
            background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABKElEQVQ4ja3UvUvDQBzG8W+Sa1pjlxZBcHBw6SBoBzs4qjgIYkFwkTr5trkpdOjiqA6CdBAEBds/QjsJOrj5B+jsZITaNrTWxCEWfDltz+QZf3f34Q6OR6sW0yawD+SAJGp5Bs6BbQHsAVuKQCeJj7OODqz8E/mcdR3158iS1ENAAFCGIqkF4mvXwaHYVAHPeQoGxVev8F4b1MvZ7pAxPClFrMVTNLOf2tmsdP0HZM0dYmWPv8yimU2MwXGcyzy8tXqDWncljKEMfTO7/g0HUpgTG7TvL2g/VKQIgPg+aN4egYhiji0Tc13EyDTuyyNOJf8rIoUAmjcHaIYgMrqE17Cpl+b/RAC0ajHtdd3VQ0L92XYIjq3j90nQnAhgB9Dw6yShCHSKrfAOLm1CEDXJmEAAAAAASUVORK5CYII=') no-repeat center
        input
          opacity 0
        .cells-check__icon
          width 0.2rem
          height 0.2rem
          flex-shrink 0
          margin-right 0.1rem
          background url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAj0lEQVQ4je3UIQ7CQBCF4W8rCAJDr0C4FdcARwhIMNyBY5EegSLapEUtogsCt5WkfzJmkvdnzLzQdHGGCzYo5fHEDdsCZ0SsETJnlbKn0HTxkSR15jUfStxD08WY7KNYzGl7sRgr+GUSTaL/FdXy6+NL2ytRh6aL17Q7GvolhyUOeBXYGb6/MnRLzlQpu38DuegvLcjd0yMAAAAASUVORK5CYII=') no-repeat center center
          background-size 0.2rem
        .cells-check__title
          font-size 0.2rem
  .textarea
    display flex
    margin-top 0.3rem
    .textarea-title
      font-size 0.26rem
      margin-left 0.1rem
      padding 0.1rem 0 0.1rem 0
    textarea
      width 85%
      height 1.5rem
      border-radius 0.08rem
      border 1px solid rgba(255, 255, 255, 0.2)
      background rgba(255, 255, 255, 0.08)
      padding 0.1rem
      font-size 0.2rem
      outline none
      &:focus
        box-shadow 0 0 0 1px rgba(66, 93, 178, 0.2)
  .captcha
    margin 0.3rem 0 0.15rem
    font-size 0.26rem
    margin-left 0.12rem
    .imgs
      display inline
      padding 0.08rem 0.1rem 0.1rem
      border 1px solid rgba(255, 255, 255, 0.2)
      background rgba(255, 255, 255, 0.08)
      border-right none
      position relative
      top 0.01rem
      img
        width 0.2rem
        height 0.2rem
        position relative
        top -0.02rem
    .captcha-img
      height 0.5rem
      border-radius 0 0.03rem 0.03rem 0
    input
      border 1px solid rgba(255, 255, 255, 0.2)
      background rgba(255, 255, 255, 0.08)
      padding 0.1rem
      font-size 0.2rem
      outline none
      width 4rem
      border-radius 0.03rem 0 0 0.03rem
  .content-block
    background-color #3b6ae0
    margin 0.5rem auto 0.24rem
    cursor pointer
    display block
    font-size 0.3rem
    font-weight 400
    height 0.84rem
    width 4rem
    -webkit-transition all 0.3s
    transition all 0.3s
    line-height 0.84rem
    text-align center
    border-radius 0.08rem
    -webkit-tap-highlight-color rgba(0, 0, 0, 0)
</style>
